// extracted by mini-css-extract-plugin
export default {"biobar-menu-button":"styles_biobar-menu-button__vuXqe","bar1":"styles_bar1__jKhz2","bar2":"styles_bar2__WNi3V","bar3":"styles_bar3__veqT7","change":"styles_change__mjy+n"};